import { createSlice } from "@reduxjs/toolkit";
import { getCalmYourEczemaNaturallyById, updateCalmYourEczemaNaturallyById, deleteCalmYourEczemaNaturally,createCalmYourEczemaNaturally,getAllCalmYourEczemaNaturally } from "../../API/FormsData/CalmYourEczemaNaturally";

const initialState = {
    getallCalmYourEczemaNaturally: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const calmYourEczemaNaturallySlice = createSlice({
  name: "CalmYourEczemaNaturally",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCalmYourEczemaNaturallyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCalmYourEczemaNaturallyById.fulfilled, (state, action) => {
        state.loading = false;
        state.getCalmYourEczemaNaturally = [action.payload]; // Flat CalmYourEczemaNaturally object array
        state.error = null;
      })
      .addCase(getCalmYourEczemaNaturallyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCalmYourEczemaNaturallyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCalmYourEczemaNaturallyById.fulfilled, (state, action) => {
        state.loading = false;
        state.updateCalmYourEczemaNaturally = [action.payload]; // Flat CalmYourEczemaNaturally object array
        state.error = null;
      })
      .addCase(updateCalmYourEczemaNaturallyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCalmYourEczemaNaturally.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCalmYourEczemaNaturally.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteCalmYourEczemaNaturally = [action.payload]; // Flat CalmYourEczemaNaturally object array
        state.error = null;
      })
      .addCase(deleteCalmYourEczemaNaturally.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllCalmYourEczemaNaturally.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCalmYourEczemaNaturally.fulfilled, (state, action) => {
        state.loading = false;
        state.getallCalmYourEczemaNaturally = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllCalmYourEczemaNaturally.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createCalmYourEczemaNaturally.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCalmYourEczemaNaturally.fulfilled, (state, action) => {
        state.loading = false;
        state.createCalmYourEczemaNaturally = [action.payload]; // Flat CalmYourEczemaNaturally object array
        state.error = null;
      })
      .addCase(createCalmYourEczemaNaturally.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default calmYourEczemaNaturallySlice.reducer;